import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "s-mt-lg s-notification--card__date" }
const _hoisted_2 = { class: "s-notification--card__title s-mt-sm" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: _normalizeClass(["s-notification--card", { 'row items-center': _ctx.isColumnOrientation }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isColumnOrientation && !_ctx.isMobile ? 'col-9' : 'col-12')
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.dateSendAt(_ctx.notification)), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.notification.title), 1),
        (_ctx.notification.message)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "s-notification--card__text s-mt-sm",
              innerHTML: _ctx.notification.message
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["s-pt-md text-right", _ctx.isColumnOrientation && !_ctx.isMobile ? 'col-3' : 'col-12'])
      }, [
        (!_ctx.notification.readAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_s_btn, {
                label: "Прочитать",
                type: "secondary",
                icon: "app:status",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('setNotificationReaded')))
              }, {
                loading: _withCtx(() => [
                  _createVNode(_component_q_spinner_dots)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, { "content-class": "s-tooltip" }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode(" Отметить уведомление как прочитанное ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["class"]))
}